import React, {useCallback, useEffect, useState} from "react";
import EATabs from "../../EATabs";
import EABetriebsakteMainContainer from "../EABetriebsakteMainContainer";
import {useForm} from "../../../utils/FormUtils";
import {useHttpSortById} from "../../../utils/usePreformattedHttp";
import {
    deleteJahresbericht, getEbtImportForAnlage,
    getJahresberichtAnlagenForBetrieb,
    getJahresberichtByIDEndpoint,
    getJahresberichtEndpoint,
    getJahresberichtJahreForAnlage,
    getKanalnetzSelbstueberwachungspflichtForAnlage,
    getPrintJahresberichtEndpoint,
    jahresberichtEinreichen,
    postJahresbericht,
    postJahresberichtWithUebernahme,
    putJahresbericht,
    updateJahresberichtFreigabe, uploadEbtFile,
} from "../../../services/AnlagenService";
import EADialog from "../../EADialog";
import EATextField from "../../EATextField";
import EAButton from "../../EAButton";
import {Grid} from "@material-ui/core";
import EATable from "../../EATable";
import {createCalculatedColumn, createColumn, createComponentColumn} from "../../../utils/ColumnUtils";
import EATableActionButton from "../../tableComponents/EATableActionButton";
import EAButtonBar from "../../EAButtonBar";
import * as PropTypes from "prop-types";
import {logger} from "../../../services/LogService";
import {
    DurchflusspruefungValues,
    JahresberichtValues, KanalzustandValues,
    StatusAQSValues,
    StatusExterneValues,
    StatusParameterMesswerte
} from "../../../consts/valueLists";
import _ from "lodash";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import {BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBS} from "../../../consts/funktionaleRollen";
import {toast} from "react-toastify";
import http, {handleApiException, useHttp} from "../../../services/HttpService";
import routes from "../../../consts/routes.json";
import CircularProgress from "@material-ui/core/CircularProgress";
import {createJahresberichtSchema} from "./JahresberichtObjects";
import {ABGEWIESEN, FREIGEGEBEN} from "../../../consts/freigabestatus";
import FreigabeDialog from "../betrieb/FreigabeDialog";
import {useConfirmation} from "../../ConfirmationDialog/ConfirmationDialogProvider";
import EADownloadButton from "../../EADownloadButton";

function AnlageTableDialog(props) {
    const [filteredData, setFilteredData] = useState([]);
    const [filter, setFilter] = useState("");

    let [{data, loading}] = useHttpSortById({
        url: getJahresberichtAnlagenForBetrieb(props.betriebsId),
        timeout: 6000000,
    });

    useEffect(() => {
        if (data) {
            setFilteredData([
                ...data.filter((item) => {
                    return (
                        item.id !== props.anlageId &&
                        (!filter ||
                            item.betrieb.value.toLowerCase().includes(filter.toLowerCase()) ||
                            item.bezeichnung.toLowerCase().includes(filter.toLowerCase()))
                    );
                }),
            ]);
        }
    }, [data, props.anlageId, filter, loading]);

    return (
        <EADialog
            open={props.open}
            titleChildren={"Anlage auswählen"}
            content={
                <div style={{width: "700px", maxHeight: "520px", minHeight: "400px"}}>
                    <div className="gridl" style={{gridTemplateColumns: "repeat(3,auto)", paddingBottom: "8px"}}>
                        <EATextField
                            value={filter}
                            onChange={(e) => {
                                e.preventDefault();
                                setFilter(e.target.value);
                            }}
                            id="anlageFilter"
                            data-cy="anlageFilter"
                            label="Suchkriterium"
                        />
                        <div>
                            <EAButton
                                onClick={() => {
                                    setFilter("");
                                }}
                                id="anlageFilterSucheReset"
                                data-cy="anlageFilterSucheReset"
                                label="Zurücksetzen"
                            />
                        </div>
                    </div>
                    <EATable
                        id="anlageAuswahl"
                        initialSortColumn="mipNr"
                        columns={[
                            createComponentColumn(
                                "actions",
                                (row, index) => {
                                    return (
                                        <Grid container spacing={1} justify="center">
                                            <Grid item>
                                                <EATableActionButton id={"selectAnlage-" + index} iconName="ico-check">
                                                    <span
                                                        onClick={() => {
                                                            setFilter("");
                                                            props.onClickOk(row);
                                                        }}
                                                        className={"w-100"}
                                                        style={{
                                                            height: "100%",
                                                            display: "block",
                                                        }}
                                                    />
                                                </EATableActionButton>
                                            </Grid>
                                        </Grid>
                                    );
                                },
                                "",
                                null,
                                {width: "50px", padding: "0"}
                            ),
                            createCalculatedColumn(
                                "betrieb",
                                (row) => {
                                    return row.betrieb.value;
                                },
                                "Betrieb"
                            ),
                            createColumn("bezeichnung", "Abwasseranlage"),
                        ]}
                        data={filteredData}
                        loading={!data || loading}
                    />
                </div>
            }
            buttons={
                <EAButtonBar>
                    <EAButton id={"btnAbbrechen"} data-cy={"btnAbbrechen"} label={"Abbrechen"}
                              onClick={props.onClickCancel}/>
                </EAButtonBar>
            }
            closeFunction={props.onClickCancel}
        />
    );
}

AnlageTableDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClickCancel: PropTypes.func.isRequired,
    onClickOk: PropTypes.func.isRequired,
};

function ParameterTableDialog(props) {
    const [filteredData, setFilteredData] = useState([]);
    const [filter, setFilter] = useState("");

    const [{data, loading}] = useHttpSortById({
        url: getJahresberichtEndpoint(props.betriebsId),
        timeout: 6000000,
    });

    useEffect(() => {
        if (data) {
            setFilteredData([
                ...data.filter((item) => {
                    return (
                        item.anlage.id === props.anlage.id &&
                        (!filter ||
                            item.anlage.bezeichnung.toLowerCase().includes(filter.toLowerCase()))
                    );
                }),
            ]);
        }
    }, [data, props.anlage, filter, loading]);

    return (
        <EADialog
            open={props.open}
            titleChildren={"Jahresbericht auswählen"}
            content={
                <div style={{width: "700px", maxHeight: "520px", minHeight: "400px"}}>
                    <div className="gridl" style={{gridTemplateColumns: "repeat(3,auto)", paddingBottom: "8px"}}>
                        <EATextField
                            value={filter}
                            onChange={(e) => {
                                e.preventDefault();
                                setFilter(e.target.value);
                            }}
                            id="anlageFilter"
                            data-cy="anlageFilter"
                            label="Suchkriterium"
                        />
                        <div>
                            <EAButton
                                onClick={() => {
                                    setFilter("");
                                }}
                                id="anlageFilterSucheReset"
                                data-cy="anlageFilterSucheReset"
                                label="Zurücksetzen"
                            />
                        </div>
                    </div>
                    <EATable
                        id="anlageAuswahl"
                        initialSortColumn="mipNr"
                        columns={[
                            createComponentColumn(
                                "actions",
                                (row, index) => {
                                    return (
                                        <Grid container spacing={1} justify="center">
                                            <Grid item>
                                                <EATableActionButton id={"selectAnlage-" + index} iconName="ico-check">
                                                    <span
                                                        onClick={() => {
                                                            setFilter("");
                                                            props.onClickOk(row);
                                                        }}
                                                        className={"w-100"}
                                                        style={{
                                                            height: "100%",
                                                            display: "block",
                                                        }}
                                                    />
                                                </EATableActionButton>
                                            </Grid>
                                        </Grid>
                                    );
                                },
                                "",
                                null,
                                {width: "50px", padding: "0"}
                            ),
                            createColumn("anlage.bezeichnung", "Abwasseranlage"),
                            createCalculatedColumn(
                                "jahr",
                                (row) => {
                                    return new Date(row.bis).getFullYear();
                                },
                                "Jahr"
                            ),
                        ]}
                        data={filteredData}
                        loading={!data || loading}
                    />
                </div>
            }
            buttons={
                <EAButtonBar>
                    <EAButton id={"btnAbbrechen"} data-cy={"btnAbbrechen"} label={"Abbrechen"}
                              onClick={props.onClickCancel}/>
                </EAButtonBar>
            }
            closeFunction={props.onClickCancel}
        />
    );
}

ParameterTableDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClickCancel: PropTypes.func.isRequired,
    onClickOk: PropTypes.func.isRequired,
};

function JahresberichtDatenView(props) {
    const tabAnlage = "Jahresbericht";
    const [berichtID, setBerichtID] = useState("");
    const readonly = !berichtID ? false : props.modus === "l";

    const confirm = useConfirmation();

    const {
        values,
        setErrors,
        formFactory,
        validate,
        setValues,
        setSchema
    } = useForm({
        readonly,
        schema: createJahresberichtSchema(),
    });
    const [{loading: berichtDataLoading}, refetch] = useHttp(getJahresberichtByIDEndpoint(berichtID), {manual: true});

    const [selectedTab, setSelectedTab] = useState(tabAnlage);
    const [jahresberichtAnlageDlgOpen, setJahresberichtAnlageDlgOpen] = useState(false);
    const [parameterDlgOpen, setParameterDlgOpen] = useState(false);

    const [freigabeDialogOpen, setFreigabeDialogOpen] = useState(false);
    const [freigabeKommentar, setFreigabeKommentar] = useState("");

    const [saveActionLoading, setSaveActionLoading] = useState(false);

    const [datesDisabled, setDatesDisabled] = useState(true);

    const [currentVersion, setCurrentVersion] = useState(null);

    const [jahre, setJahre] = useState(null);
    const [moeglicheJahre, refetchMoeglicheJahre] = useHttp(getJahreEndpoint(), {manual: true});
    // eslint-disable-next-line
    const [kanalnetzSelbstueberwachung, refetchKanalnetzSelbstueberwachungspflicht] = useHttp(getKanalnetzSelbstueberwachungEndpoint(), {manual: true});
    const [refetchedJahre, setRefetchedJahre] = useState(false);
    const [currentYear, setCurrentYear] = useState(null);

    const [initialized, setInitialized] = useState(false);

    const [ebtImportAllowed, setEbtImportAllowed] = useState(false);

    useEffect(() => {
        if (values?.anlage?.id && berichtID === "neu") {
            refetchKanalnetzSelbstueberwachungspflicht().then((r) => {
                if (r?.data === true) {
                    setValues((prevValues) => ({
                        ...prevValues,
                        kanalzustand: KanalzustandValues.find((item) => item.id === "ANGEFORDERT"),
                    }));
                }
                else {
                    setValues((prevValues) => ({
                        ...prevValues,
                        kanalzustand: null,
                    }));
                }
            });
        }
    }, [values.anlage?.id, refetchKanalnetzSelbstueberwachungspflicht, berichtID, setValues]);

    function getJahreEndpoint() {
        if (values.anlage && values.anlage.id) {
            return getJahresberichtJahreForAnlage(values.anlage.id)
        }
        return "";
    }

    function getKanalnetzSelbstueberwachungEndpoint() {
        if (values.anlage && values.anlage.id) {
            return getKanalnetzSelbstueberwachungspflichtForAnlage(values.anlage.id)
        }
        return "";
    }

    const buildTabs = () => {
        return [tabAnlage];
    };

    const backgroundColor = values && values.history ? {background: "#FFFFFF", filter: "sepia()"} : {};
    extractBerichtID();

    useEffect(() => {
        setSchema(createJahresberichtSchema());
    }, [setSchema]);

    useEffect(() => {
        if (values.anlage && values.anlage.id) {
            refetchMoeglicheJahre().then(() => {
                setRefetchedJahre(true);
            });
        }
    }, [values.anlage, refetchMoeglicheJahre])

    function handleCloseAnlageDialog() {
        setJahresberichtAnlageDlgOpen(false);
    }

    function handleCloseAnlageDialogOk(anlage) {
        setJahresberichtAnlageDlgOpen(false);
        const updatedValues = {...values};
        updatedValues.anlage = {...anlage};
        updatedValues.anlageBezeichnung = anlage.bezeichnung;
        setValues(updatedValues);
    }

    function handleCloseParameterDialog() {
        setParameterDlgOpen(false);
    }

    function handleCloseParameterDialogOk(jahresbericht) {
        setParameterDlgOpen(false);
        const updatedValues = {...values};
        updatedValues.parameter = jahresbericht;
        updatedValues.parameterBezeichnung = jahresbericht.anlage.bezeichnung + " (" + new Date(jahresbericht.bis).getFullYear() + ")";
        setValues(updatedValues);
    }

    useEffect(() => {
        const updateDateFields = (year) => {
            if (year) {
                const fromDate = new Date(year, 0, 1);
                const toDate = new Date(year, 11, 31);
                setValues({
                    ...values,
                    von: fromDate,
                    bis: toDate,
                });
                setDatesDisabled(false);
            } else {
                setValues({
                    ...values,
                    von: null,
                    bis: null,
                });
                setDatesDisabled(true);
            }
        };

        if (values.jahr) {
            if (values.jahr.value === currentYear) return;
            setCurrentYear(values.jahr.value);
            updateDateFields(parseInt(values.jahr.value));
        } else {
            if (currentYear === 0) return;
            setCurrentYear(0);
            updateDateFields(parseInt(null));
        }
    }, [setValues, values, currentYear]);


    useEffect(() => {
        if (moeglicheJahre.data && refetchedJahre) {
            const jahreArray = moeglicheJahre.data.map((jahr) => {
                return {id: jahr.toString(), value: jahr.toString()};
            });


            if (values.bis) {
                const bisJahr = new Date(values.bis).getFullYear().toString();
                jahreArray.push({ id: bisJahr, value: bisJahr });
            }

            if (jahre) {
                setJahre(removeDuplicateYears([...jahreArray]));
            } else {
                setJahre(jahreArray);
            }
            setRefetchedJahre(false);
        }
    }, [moeglicheJahre, jahre, setJahre, refetchedJahre, values.bis]);

    function removeDuplicateYears(jahre) {
        const uniqueYearsObj = jahre.reduce((acc, year) => {
            acc[year.id] = year;
            return acc;
        }, {});
        return Object.values(uniqueYearsObj);
    }


    function extractBerichtID() {
        const currentURL = new URL(window.location.href);
        const pathParts = currentURL.pathname.split('/');
        const jahresberichtIndex = pathParts.indexOf('jahresbericht');

        if (jahresberichtIndex !== -1 && jahresberichtIndex < pathParts.length - 1) {
            let id = pathParts[jahresberichtIndex + 1];
            if (id !== berichtID) {
                setBerichtID(id);
                setInitialized(false);
            }
        }
    }

    useEffect(() => {
        if (initialized) return;
        if (berichtID && berichtID !== "neu") {
            refetch().then(({data: valuesToSet}) => {
                let year = new Date(valuesToSet.bis).getFullYear();
                let newYears;
                if (jahre) {
                    newYears = [...jahre, {id: year.toString(), value: year.toString()}]
                    newYears = removeDuplicateYears(newYears);
                } else {
                    newYears = [{id: year.toString(), value: year.toString()}]
                }

                logger.debug("Geladene Anlage", valuesToSet);
                setErrors({});
                valuesToSet.status = JahresberichtValues.find(item => item.id === valuesToSet.status);
                valuesToSet.statusAQS = StatusAQSValues.find(item => item.id === valuesToSet.statusAQS);
                valuesToSet.statusExterne = StatusExterneValues.find(item => item.id === valuesToSet.statusExterne);
                valuesToSet.statusMesswerte = StatusParameterMesswerte.find(item => item.id === valuesToSet.statusMesswerte);
                valuesToSet.kanalzustand = KanalzustandValues.find(item => item.id === valuesToSet.kanalzustand);
                valuesToSet.durchflusspruefung = DurchflusspruefungValues.find(item => item.id === valuesToSet.durchflusspruefung);
                valuesToSet.jahr = newYears.find(item => item.id === "" + new Date(valuesToSet.bis).getFullYear());
                valuesToSet.anlageBezeichnung = valuesToSet.anlage.bezeichnung;
                setValues(valuesToSet);
                if (currentVersion === null) setCurrentVersion(_.cloneDeep(valuesToSet));

                setJahre(newYears);
            }).catch((e) => {
                handleApiException(e, "Error loading bericht");
            });
        } else if (berichtID && berichtID === "neu") {
            setValues({});
            setJahre(null);
        }

        setInitialized(true);
    }, [berichtID, currentVersion, jahre, refetch, setErrors, setValues, initialized]);


    const closeJahresberichtDatenView = useCallback((reload) => {
        const currentURL = props.history.location.pathname;
        if (reload) {
            props.history.replace(currentURL.replace(/\/jahresbericht\/.*/, "/jahresbericht/uebersicht/?reload=true"));
        } else {
            props.history.replace(currentURL.replace(/\/jahresbericht\/.*/, "/jahresbericht/uebersicht/"));
        }
    }, [props.history]);

    const deleteBericht = useCallback(() => {
        setSaveActionLoading(true);
        deleteJahresbericht(values.id)
            .then(() => {
                toast.success("Bericht erfolgreich gelöscht");
                closeJahresberichtDatenView(true);
                props.reloadNavigation();
            })
            .catch(ex => {
                setSaveActionLoading(false);
                const response = ex?.response;
                if (!response) {
                    return;
                }
                let newErrors = null;
                if (response?.data?.validationErrors) {
                    const errorMessage = Object.values(response.data.validationErrors)[0];
                    toast.warn("Validierung fehlgeschlagen: " + errorMessage);
                    newErrors = ex.response.data.validationErrors;
                }
                setErrors(newErrors);
                if (!newErrors) {
                    handleApiException(ex);
                }
            });
    }, [closeJahresberichtDatenView, setErrors, values.id, props]);

    useEffect(() => {
        const isPlausibilisiert = values.status && values.status.id === "PLAUSIBILISIERT";
        const isEingereicht = values.status && values.status.id === "EINGEREICHT";

        var isEditAllowed = userHasAnyRole([BETREIBER, ZUST_SBS, FACHADMIN, SYSTEMADMIN])
            && (!userHasAnyRole(BETREIBER) || (userHasAnyRole(BETREIBER) && !isEingereicht))
            && !isPlausibilisiert;


        if (isEditAllowed) {
            props.setToggleAllowed(true);
        } else {
            props.setToggleAllowed(false);
        }
    }, [values, props]);

    function toLeseModus(id) {
        props.history.replace(calculateAnlagenLink(id));
        setSaveActionLoading(false);
    }

    function calculateAnlagenLink(id, modus = "modus=l") {
        let pfad = `${routes.BETRIEBSAKTE_RAW}/${props.betriebsId}`;
        pfad = `${pfad}/jahresbericht/${id}/jahresberichtdaten?${modus}`;
        return pfad;
    }

    function isSameRoleAsErsteller() {
        if (values && values.id) {
            if (!values.eingereichtVon) {
                return true;
            }

            if (userHasAnyRole([ZUST_SBS]) && values.eingereichtVon.funktionaleRolle.includes(ZUST_SBS)) {
                return true;
            }

            if (userHasAnyRole([BETREIBER]) && values.eingereichtVon.funktionaleRolle.includes(BETREIBER)) {
                return true;
            }

            if (userHasAnyRole([SYSTEMADMIN, FACHADMIN])) {
                return true;
            }
        }
        return false
    }

    const [{ data: ebtImportData, loading: ebtImportLoading }, refetchEbtImport] = useHttp(
        values.anlage?.id ? getEbtImportForAnlage(values.anlage.id) : null,
        { manual: true }
    );

    useEffect(() => {
        if (values.anlage?.id) {
            refetchEbtImport().then((res) => {
                setEbtImportAllowed(res?.data === true); // Boolean aus API
            }).catch(() => {
                setEbtImportAllowed(false);
            });
        }
    }, [values.anlage?.id, refetchEbtImport]);


    const renderButtonBar = () => {
        const isEingereicht = values.status && values.status.id === "EINGEREICHT";
        const isInBearbeitung = values.status && values.status.id === "IN_BEARBEITUNG";
        const isBearbeitungAbgeschlossen = values.status && values.status.id === "BEARBEITUNG_ABGESCHLOSSEN";

        return (
            <EAButtonBar
                style={{
                    marginTop: "var(--buttonBar-spacing-top)",
                    marginBottom: "10px",
                    marginRight: "10px",
                    marginLeft: "10px",
                }}
            >
                {isSameRoleAsErsteller() && formFactory.renderButton("delete", "delete", "Löschen", (e) => {
                    confirm({
                        title: "Löschen bestätigen",
                        description: "Soll der Jahresbericht wirklich gelöscht werden?",
                        onSubmit: () => {
                            e.preventDefault();
                            deleteBericht();
                        },
                        onClose: () => {
                        },
                    });
                })}
                {formFactory.renderButton("cancel", "cancel", "Abbrechen", () => closeJahresberichtDatenView(false))}
                {formFactory.renderButton(
                    "saveBericht",
                    "saveBericht",
                    "Speichern",
                    (e) => {
                        e.preventDefault();
                        saveBericht();
                    },
                    {
                        color: "primary"
                    }
                )}
                {(isInBearbeitung || isBearbeitungAbgeschlossen) && formFactory.renderButton(
                    "saveBerichtAndSubmit",
                    "saveBerichtAndSubmit",
                    "Speichern und Einreichen",
                    (e) => {
                        e.preventDefault();
                        saveBericht(true);
                    },
                    {
                        color: "primary",
                    }
                )}
                {isEingereicht &&
                    userHasAnyRole([FACHADMIN, SYSTEMADMIN, ZUST_SBS]) &&
                    formFactory.renderButton("editFreigabe", "editFreigabe", "Freigabe bearbeiten", () => setFreigabeDialogOpen(true), {
                        color: "primary",
                    })}

                {values.id && ebtImportAllowed && formFactory.renderButton(
                    "ebtImport",
                    "ebtImport",
                    "eBT-Import",
                    () => setEbtImportDialogOpen(true),
                    { color: "secondary" }
                )}

                {values && values.id && <EADownloadButton
                    id="print"
                    label="Drucken"
                    url={getPrintJahresberichtEndpoint(values.id)}
                />}
            </EAButtonBar>
        );
    };

    const [ebtImportDialogOpen, setEbtImportDialogOpen] = useState(false);
    const [ebtFile, setEbtFile] = useState(null);
    const [ebtUploadLoading, setEbtUploadLoading] = useState(false);

    // NEU: Import-Ergebnis speichern
    const [importResult, setImportResult] = useState(null);
    const [importResultDialogOpen, setImportResultDialogOpen] = useState(false);

    const handleEbtFileUpload = async () => {
        if (!ebtFile) return;

        setEbtUploadLoading(true);

        try {
            const response = await uploadEbtFile(values.id, ebtFile);

            // 🔹 nur die Liste der Messstellen aus dem DTO übernehmen
            const messstellen = response.data?.result?.messstellen ?? [];

            toast.success("eBT-Import erfolgreich!");

            setImportResult(messstellen);
            setImportResultDialogOpen(true);
            refetch();

        } catch (err) {
            // Axios-Fehler → Backend-Antwort auslesen
            if (err.response && err.response.data?.message) {
                toast.error("eBT-Import fehlgeschlagen: " + err.response.data.message);
            } else {
                toast.error("Fehler beim Übertragen der Importdatei.");
            }
        } finally {
            setEbtUploadLoading(false);
            setEbtImportDialogOpen(false);
            setEbtFile(null);
        }
    };

    const prepareForUpload = () => {
        const bericht = _.cloneDeep(values);
        if (bericht.status) bericht.status = bericht.status.id;
        if (bericht.statusAQS) bericht.statusAQS = bericht.statusAQS.id;
        if (bericht.statusExterne) bericht.statusExterne = bericht.statusExterne.id;
        if (bericht.statusMesswerte) bericht.statusMesswerte = bericht.statusMesswerte.id;
        if (bericht.kanalzustand) bericht.kanalzustand = bericht.kanalzustand.id;
        if (bericht.durchflusspruefung) bericht.durchflusspruefung = bericht.durchflusspruefung.id;
        bericht.geaendert = new Date();

        return bericht;
    };

    const saveBericht = async (einreichen = false) => {
        const e = validate();

        if (e && Object.keys(e).length > 0) {
            return;
        }
        setSaveActionLoading(true);
        const objectToSave = prepareForUpload();
        logger.debug("SaveBericht", objectToSave);
        let savedAnlage = null;
        try {
            if (values.id) {
                if (einreichen) {
                    savedAnlage = await jahresberichtEinreichen(objectToSave);
                }
                else {
                    savedAnlage = await putJahresbericht(objectToSave);
                }
            } else {
                if (objectToSave.parameter) {
                    savedAnlage = await postJahresberichtWithUebernahme(objectToSave, objectToSave.parameter.id);
                } else {
                    savedAnlage = await postJahresbericht(objectToSave);
                }
            }
            toast.success("Bericht erfolgreich gespeichert");
            setValues({
                id: savedAnlage?.data?.id,
                ...values,
                status: JahresberichtValues.find(item => item.id === savedAnlage?.data?.status)
            });
            toLeseModus(savedAnlage?.data?.id);
            props.reloadNavigation();
            setErrors(null);
        } catch (ex) {
            setSaveActionLoading(false);
            const response = ex?.response;
            if (!response) {
                return;
            }
            let newErrors = null;
            if (response?.data?.validationErrors) {
                const errorMessage = Object.values(response.data.validationErrors)[0];

                toast.warn("Validierung fehlgeschlagen: " + errorMessage);
                newErrors = ex.response.data.validationErrors;
            }
            setErrors(newErrors);
            if (!newErrors) {
                handleApiException(ex);
            }
        }
    };

    if (saveActionLoading || (berichtID && berichtDataLoading)) {
        return (
            <div style={{display: "flex", justifyContent: "center", alignItems: "center",}}>
                <CircularProgress/>
            </div>
        );
    }

    function submitFreigabestatus(freigabestatus) {
        putJahresbericht(prepareForUpload())
            .then(() => {
                setFreigabeDialogOpen(false);
                updateJahresberichtFreigabe(berichtID, {kommentar: freigabeKommentar, neuerStatus: freigabestatus})
                    .then(() => {
                        if (freigabestatus === FREIGEGEBEN) {
                            setValues({
                                ...values,
                                status: JahresberichtValues.find(item => item.id === "PLAUSIBILISIERT")
                            });
                        } else {
                            setValues({
                                ...values,
                                status: JahresberichtValues.find(item => item.id === "IN_BEARBEITUNG")
                            });
                        }
                        toLeseModus(berichtID);
                        if (freigabestatus === FREIGEGEBEN) {
                            toast.success("Der Jahresbericht wurde erfolgreich freigegeben.");
                        } else {
                            toast.success("Der Jahresbericht wurde erfolgreich zurückgewiesen.");
                        }
                    });
            })
            .catch((e) => {
                if (!e.isValidationHandled) {
                    logger.error("Freigabe eines Jahresberichts ist fehlgeschlagen: ", e);
                    toast.error("Das Freigeben des Jahresberichts ist fehlgeschlagen! Alle anderen Änderungen wurden zuvor gespeichert.");
                }
            })
            .catch((err) => {
                if (!err.isValidationHandled) {
                    logger.error("Speichern eines Jahresberichts ist fehlgeschlagen: ", err);
                    toast.error("Beim Speichern vor der Freigabe des Jahresberichts ist ein Fehler aufgetreten!");
                }
            });
    }

    function freigabeBearbeitung(freigabestatus) {
        if (freigabestatus === ABGEWIESEN) {
            confirm({
                title: "Zurückweisung bestätigen",
                description: "Wollen Sie die Freigabe für den Jahresbericht wirklich zurückweisen?",
                onSubmit: () => {
                    submitFreigabestatus(freigabestatus);
                },
                onClose: () => {
                },
            });
        } else {
            submitFreigabestatus(freigabestatus);
        }
    }

    return (
        <EABetriebsakteMainContainer style={backgroundColor}>
            <EATabs
                value={selectedTab}
                onChange={(newSelectedTab) => setSelectedTab(newSelectedTab)}
                options={buildTabs()}
            />
            {jahresberichtAnlageDlgOpen && (
                <AnlageTableDialog
                    open={jahresberichtAnlageDlgOpen}
                    onClickCancel={handleCloseAnlageDialog}
                    onClickOk={handleCloseAnlageDialogOk}
                    betriebsId={props.betriebsId}
                    anlageId={berichtID}
                />
            )}
            {parameterDlgOpen && (
                <ParameterTableDialog
                    open={parameterDlgOpen}
                    onClickCancel={handleCloseParameterDialog}
                    onClickOk={handleCloseParameterDialogOk}
                    betriebsId={props.betriebsId}
                    anlage={values.anlage}
                />
            )}

            {ebtImportDialogOpen && (
                <EADialog
                    open={ebtImportDialogOpen}
                    titleChildren="eBT-Import"
                    content={
                        <div style={{ width: "400px" }}>
                            <input
                                type="file"
                                accept=".xml,.zip"
                                onChange={(e) => setEbtFile(e.target.files[0])}
                            />

                            {ebtFile && (
                                <p style={{ marginTop: "10px" }}>
                                    Ausgewählte Datei: <b>{ebtFile.name}</b>
                                </p>
                            )}
                        </div>
                    }
                    buttons={
                        <EAButtonBar>
                            <EAButton
                                id="btnCancelEbt"
                                label="Abbrechen"
                                onClick={() => {
                                    setEbtImportDialogOpen(false);
                                    setEbtFile(null);
                                }}
                            />
                            <EAButton
                                id="btnUploadEbt"
                                label={ebtUploadLoading ? "Wird hochgeladen..." : "Hochladen"}
                                disabled={!ebtFile || ebtUploadLoading}
                                onClick={handleEbtFileUpload}
                                color="primary"
                            >
                                {ebtUploadLoading && (
                                    <CircularProgress size={18} style={{ marginLeft: "8px" }} />
                                )}
                            </EAButton>
                        </EAButtonBar>
                    }
                    closeFunction={() => setEbtImportDialogOpen(false)}
                />
            )}

            {importResultDialogOpen && (
                <EADialog
                    open={importResultDialogOpen}
                    titleChildren="Import-Übersicht"
                    content={
                        <div style={{ width: "700px" }}>

                            {importResult.map((ms, idx) => (
                                <div key={idx} style={{ marginBottom: "24px" }}>
                                    <h3>
                                        Messstelle {ms.messstellennummer}
                                        {" – "}
                                        {ms.messstellenbezeichnung}
                                    </h3>

                                    <table className="ea-table" style={{ width: "100%", marginTop: "8px" }}>
                                        <thead>
                                        <tr>
                                            <th style={{ textAlign: "left" }}>Parameter-Nr.</th>
                                            <th style={{ textAlign: "left" }}>Parametername</th>
                                            <th>Anforderung</th>
                                            <th>Ergänzung</th>
                                            <th>Anzahl Werte</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {ms.parameter?.map((p, pIndex) => (
                                            <tr key={pIndex}>
                                                <td>{p.parameternummer}</td>
                                                <td>{p.parametername}</td>
                                                <td style={{ textAlign: "center" }}>
                                                    {p.ausBescheidVorlage ? "✔" : "–"}
                                                </td>
                                                <td style={{ textAlign: "center" }}>
                                                    {p.zusaetzlicherParameter ? "✔" : "–"}
                                                </td>
                                                <td style={{ textAlign: "center" }}>
                                                    {p.anzahlWerte}
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            ))}

                            {!importResult.length && (
                                <p>Keine Daten vorhanden.</p>
                            )}
                        </div>
                    }
                    buttons={
                        <EAButtonBar>
                            <EAButton
                                label="Schließen"
                                onClick={() => setImportResultDialogOpen(false)}
                                color="primary"
                            />
                        </EAButtonBar>
                    }
                />
            )}


            <div className="gridl"
                 style={{gridTemplateColumns: "1.5fr 0.5fr 0.8fr 0.8fr 1fr", margin: "10px", marginTop: "20px"}}>
                <div className="gridl" style={{gridTemplateColumns: "1fr auto"}}>
                    {formFactory.renderInput("anlageBezeichnung", "anlageBezeichnung", "Abwasserbehandlungsanlage", "text", true)}
                    {formFactory.renderButton("anlageAendern", "anlageAendern", "auswählen...", () => setJahresberichtAnlageDlgOpen(true), {
                        "data-cy": "anlageAendern",
                    })}
                </div>
                {formFactory.renderSelect(
                    "jahr",
                    "jahr",
                    "Jahr",
                    jahre,
                    !values.anlageBezeichnung,
                )}
                {formFactory.renderDatePicker(
                    "von",
                    "von",
                    "Von",
                    datesDisabled
                )}
                {formFactory.renderDatePicker(
                    "bis",
                    "bis",
                    "Bis",
                    datesDisabled
                )}
                {formFactory.renderSelect(
                    "status",
                    "status",
                    "Status",
                    JahresberichtValues,
                    true,
                )}
            </div>

            <div className="gridl" style={{gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr", margin: "10px"}}>
                {formFactory.renderSelect(
                    "statusMesswerte",
                    "status_messwerte",
                    "Status Messwerte",
                    StatusParameterMesswerte,
                    true,
                )}
                {formFactory.renderSelect(
                    "statusAQS",
                    "status_aqs",
                    "Status AQS",
                    StatusAQSValues,
                    false,
                )}
                {formFactory.renderSelect(
                    "statusExterne",
                    "status_externe",
                    "Status externe Stoffe",
                    StatusExterneValues,
                    false,
                )}
                {formFactory.renderSelect(
                    "kanalzustand",
                    "kanalzustand",
                    "Kanalzustand/Sanierung",
                    KanalzustandValues,
                    false,
                )}
                {formFactory.renderSelect(
                    "durchflusspruefung",
                    "durchflusspruefung",
                    "Durchflussprüfung an",
                    DurchflusspruefungValues,
                    false,
                )}
            </div>

            <div className="gridl" style={{gridTemplateColumns: "1fr", margin: "10px"}}>
                {formFactory.renderInput("bemerkung", "bemerkung", "Bemerkung", "text", false)}
            </div>
            {!values.id && <div className="gridl" style={{gridTemplateColumns: "1fr auto", margin: "10px"}}>
                {formFactory.renderInput("parameterBezeichnung", "parameterBezeichnung", "Ergänzende Parameter übernehmen aus...", "text", true)}
                {formFactory.renderButton("anlageAendern", "anlageAendern", "auswählen...", () => setParameterDlgOpen(true), {
                    "data-cy": "anlageAendern",
                })}
            </div>}
            {renderButtonBar()}
            <FreigabeDialog
                label="Jahresbericht"
                open={freigabeDialogOpen}
                onClose={() => setFreigabeDialogOpen(false)}
                kommentar={freigabeKommentar}
                onKommentarChange={(newValue) => setFreigabeKommentar(newValue.currentTarget.value)}
                onAblehnen={() => freigabeBearbeitung(ABGEWIESEN)}
                onFreigabe={() => freigabeBearbeitung(FREIGEGEBEN)}
                freigabeLabel={"Plausibilisierung abschließen"}
            />
        </EABetriebsakteMainContainer>
    );
}

export default JahresberichtDatenView;
